import React, { useCallback, useState, useEffect, memo, useMemo } from "react";
import { Table, Box, Flex, Text, List } from "@mantine/core";
import { modals } from "@mantine/modals";
import toast from "react-hot-toast";

import styles from "./styles.module.scss";
import ScrollAreaLayout from "../../../widgets/ScrollAreaLayout";
import EmptyNotice from "../EmptyNotice";
import { IconCoinOff } from "@tabler/icons-react";
import SkeletonTable from "../../../pages/ResearcherPage/SkeletonTable";
import { getUnpaidUnits } from "../../../services/users.service";
import ToastWarning from "../../../toast/components/toastWarning/ToastWarning";
import { leaveAfterComma } from "../../../utils/leaveAfterComma";

const UnpaidUnitModal = memo(({ context }) => {
  
  
 
  const TABLE_HEADERS = useMemo(
    () => ["#", "Publication date", "Video title", "", "Amount"],
    []
  );
  const [scrolled, setScrolled] = useState(false);
  const [unpaidUnitsData, setUnpaidUnitsData] = useState({
    isLoading: true,
    data: {},
  });

  // Calculate the total advance amount from the table data
  const calculateTotalAdvance = useCallback((data) => {
    if (!data?.main || !data.main.length) return 0;
    
    return data.main.reduce((total, item) => {
      return total + (Number(item.earning.own) || 0);
    }, 0);
  }, []);

  useEffect(() => {
    (async () => {
      const result = await getUnpaidUnits();

      if (result.error) {
        toast.error(result.error);
        modals.closeAll();
        return;
      }

      if (result.warning) {
        toast.custom(<ToastWarning text={result.warning} />);
        modals.closeAll();
        return;
      }

      if (result.data) {
        setUnpaidUnitsData((prev) => ({ ...prev, data: result.data }));
      }

      setUnpaidUnitsData((prev) => ({ ...prev, isLoading: false }));
    })();
  }, []);

  const onOpenVideoInfoPage = useCallback((videoId) => {
    window.open(`/library/${videoId}`, "_blank");
  }, []);

  // Sort data by date - newest first
  const sortedData = useMemo(() => {
    if (!unpaidUnitsData.data?.main) return [];
    
    return [...unpaidUnitsData.data.main].sort((a, b) => {
      // Convert dates to timestamps for comparison
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      // Sort descending (newest first)
      return dateB - dateA;
    });
  }, [unpaidUnitsData.data]);

  return (
    <div className={styles.modal}>
      <Box className={styles.tableWrapper}>
        {unpaidUnitsData.isLoading ? (
          <SkeletonTable columnCount={7} rowCount={5} />
        ) : !unpaidUnitsData.data?.main?.length ? (
          <Flex
            justify="center"
            align="center"
            className={styles.emptyNoticeBlock}
          >
            <EmptyNotice
              icon={<IconCoinOff size="25px" color="black" />}
              text="It's empty here yet"
              color="black"
            />
          </Flex>
        ) : (
          <ScrollAreaLayout setScrolled={setScrolled} height={450}>
            <Table withColumnBorders withBorder className={styles.table}>
              <thead
                className={`${styles.header} ${
                  scrolled ? styles.scrolled : ""
                }`}
              >
                <tr>
                  {TABLE_HEADERS.map((title, index) => (
                    <th key={index}>{title}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {sortedData.map((item, index) => (
                  <tr key={index}>
                    <td>{sortedData.length - index}</td>
                    <td>{item.date}</td>
                    <td
                      className={styles.cursorPointer}
                      onClick={() => onOpenVideoInfoPage(item.videoId)}
                    >
                      {item.videoTitle || item.videoId}
                    </td>
                    <td>{item.dueFor}</td>
                    <td>{Math.round(item.earning.own)} $</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ScrollAreaLayout>
        )}
      </Box>
    </div>
  );
});

export default UnpaidUnitModal;
